export const mockRentalHistoryEntries = [
  {
    id: "sample-rh-1",
    surveyDate: "2025-01-15",
    occupancyPercent: 91,
    averageOccupancyPercent: 89,
    notes: [
      { id: "sample-rh-1-note-1", text: "Concessions reduced in January", tags: ["concessions", "pricing"], createdAt: "2025-01-15T17:30:00.000Z", updatedAt: "2025-01-15T17:30:00.000Z" },
      { id: "sample-rh-1-note-2", text: "Follow-up call with leasing office scheduled", tags: ["follow-up"], createdAt: "2025-01-22T18:05:00.000Z", updatedAt: "2025-01-22T18:05:00.000Z" },
    ],
    rows: [
      {
        id: "sample-rh-1-row-1",
        units: 42,
        unitType: "1BR",
        unitSizeSF: 725,
        rentLow: 1925,
        rentHigh: 2145,
        netRent: 2030,
        lowSF: 2.66,
        highSF: 2.96,
      },
      {
        id: "sample-rh-1-row-2",
        units: 28,
        unitType: "2BR",
        unitSizeSF: 1010,
        rentLow: 2550,
        rentHigh: 2865,
        netRent: 2700,
        lowSF: 2.52,
        highSF: 2.84,
      },
    ],
  },
  {
    id: "sample-rh-2",
    surveyDate: "2024-10-10",
    occupancyPercent: 88,
    averageOccupancyPercent: 87,
    notes: [
      { id: "sample-rh-2-note-1", text: "Leasing velocity slowed into Q4", tags: ["leasing"], createdAt: "2024-10-10T16:00:00.000Z", updatedAt: "2024-10-10T16:00:00.000Z" },
    ],
    rows: [
      {
        id: "sample-rh-2-row-1",
        units: 42,
        unitType: "1BR",
        unitSizeSF: 725,
        rentLow: 1860,
        rentHigh: 2075,
        netRent: 1965,
        lowSF: 2.57,
        highSF: 2.86,
      },
      {
        id: "sample-rh-2-row-2",
        units: 28,
        unitType: "2BR",
        unitSizeSF: 1010,
        rentLow: 2460,
        rentHigh: 2745,
        netRent: 2590,
        lowSF: 2.44,
        highSF: 2.72,
      },
    ],
  },
  {
    id: "sample-rh-3",
    surveyDate: "2024-06-20",
    occupancyPercent: 86,
    averageOccupancyPercent: 85,
    notes: [
      { id: "sample-rh-3-note-1", text: "Seasonal turnover increased vacancy", tags: ["vacancy", "leasing"], createdAt: "2024-06-20T15:45:00.000Z", updatedAt: "2024-06-20T15:45:00.000Z" },
    ],
    rows: [
      {
        id: "sample-rh-3-row-1",
        units: 42,
        unitType: "1BR",
        unitSizeSF: 725,
        rentLow: 1795,
        rentHigh: 1995,
        netRent: 1890,
        lowSF: 2.48,
        highSF: 2.75,
      },
      {
        id: "sample-rh-3-row-2",
        units: 28,
        unitType: "2BR",
        unitSizeSF: 1010,
        rentLow: 2360,
        rentHigh: 2640,
        netRent: 2490,
        lowSF: 2.34,
        highSF: 2.61,
      },
    ],
  },
];
